import * as React from "react";

function SvgSplit(props, ref) {
  return (
    <svg
      id="Split_svg__Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 547 637"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <linearGradient
          id="Split_svg__linear-gradient"
          x1={54.93}
          y1={1037.62}
          x2={54.36}
          y2={1037.26}
          gradientTransform="matrix(354 0 0 -321 -18903 333434.01)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#3c9fe6" />
          <stop offset={1} stopColor="#77cffd" />
        </linearGradient>
        <linearGradient
          id="Split_svg__linear-gradient-2"
          x1={54.76}
          y1={1036.99}
          x2={53.76}
          y2={1037.62}
          gradientTransform="matrix(354 0 0 -321 -19062 333323.01)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.36} stopColor="#2285e1" />
          <stop offset={0.79} stopColor="#2581cb" />
        </linearGradient>
        <style>{".Split_svg__cls-4{fill:#3195e3}"}</style>
        <mask
          id="Split_svg__mask"
          x={648}
          y={93}
          width={890.87}
          height={451.55}
          maskUnits="userSpaceOnUse"
        >
          <g id="Split_svg__mask-5">
            <path
              id="Split_svg__path-4"
              fill="#fff"
              d="M1093.43 544.55h445.44V93H648v451.55h445.43z"
            />
          </g>
        </mask>
      </defs>
      <g id="Split_svg__Page-1">
        <path
          id="Split_svg__Fill-1"
          fill="url(#Split_svg__linear-gradient)"
          d="M159 516v120l354-201V315L159 516z"
        />
        <path
          id="Split_svg__Fill-2"
          fill="#77cffd"
          d="M159 231l354 201V312L159 111v120z"
        />
        <g id="Split_svg__Fill-3">
          <path
            id="Split_svg__path-3"
            className="Split_svg__cls-4"
            d="M0 324l354 201V405L0 204v120z"
          />
          <path
            id="Split_svg__path-3-2"
            data-name="path-3"
            fill="url(#Split_svg__linear-gradient-2)"
            d="M0 324l354 201V405L0 204v120z"
          />
        </g>
        <path
          id="Split_svg__Fill-4"
          className="Split_svg__cls-4"
          d="M354 0L0 201v120l354-201V0z"
        />
        <path
          id="Split_svg__Fill-5"
          d="M354 405.28V525l-105.43-59.86zM159 230.72V111l105.43 59.86z"
          fill="#2285e1"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgSplit);
